app.factory('userModel', ['$rootScope', 'baseModel', 'userService',
  function ($rootScope, baseModel, userService) {
    
    function UserModel() {
      
      var self = this;
      
      this.currentUser = null;
      this.currentUserAuthorities = null;
      this.userListCriteria = null;
      this.selectedLanguage = localStorage.getItem('edm_lang');
      this.getCurrentContextDoctorId = getCurrentContextDoctorId;
      
      this.getDataPage = function (criteria) {
        userService.getDataPage(criteria).then(
          function (dataPage) {
            $rootScope.$broadcast(Event.USER.GET_DATA_PAGE.SUCCESS, dataPage);
          },
          function (error) {
            $rootScope.$broadcast(Event.USER.GET_DATA_PAGE.ERROR, error);
          }
        )
      };
      
      this.getById = function (id) {
        userService.getById(id).then(
          function (user) {
            $rootScope.$broadcast(Event.USER.GET_BY_ID.SUCCESS, user);
          },
          function (error) {
            $rootScope.$broadcast(Event.USER.GET_BY_ID.ERROR, error);
          }
        )
      };
      
      
      this.save = function (user) {
        userService.save(user).then(
          function (savedUser) {
            $rootScope.$broadcast(Event.USER.SAVE.SUCCESS, savedUser);
            baseModel.broadcastOperationSucceeded();
          },
          function (error) {
            $rootScope.$broadcast(Event.USER.SAVE.ERROR, error);
          }
        )
      };
      
      this.update = function (user) {
        userService.update(user).then(
          function (updatedUser) {
            $rootScope.$broadcast(Event.USER.UPDATE.SUCCESS, updatedUser);
            baseModel.broadcastOperationSucceeded();
          },
          function (error) {
            $rootScope.$broadcast(Event.USER.UPDATE.ERROR, error);
          }
        )
      };
      
      this.deleteAll = function (users) {
        userService.deleteAll(users).then(
          function (data) {
            $rootScope.$broadcast(Event.USER.DELETE_ALL.SUCCESS, data);
            baseModel.broadcastOperationSucceeded();
          },
          function (error) {
            $rootScope.$broadcast(Event.USER.DELETE_ALL.ERROR, error);
            baseModel.broadcastOperationFailed();
          }
        )
      };
      
      this.updateStatus = function (user) {
        userService.updateStatus(user).then(
          function (data) {
            $rootScope.$broadcast(Event.USER.UPDATE_STATUS.SUCCESS, data);
            baseModel.broadcastOperationSucceeded();
          },
          function (error) {
            $rootScope.$broadcast(Event.USER.UPDATE_STATUS.ERROR, error);
            baseModel.broadcastOperationFailed();
          }
        )
      };
      
      this.changePassword = function (oldPassword, newPassword) {
        userService.changePassword(oldPassword, newPassword).then(
          function (user) {
            self.currentUser = user;
            self.currentUserAuthorities = resolveAuthorities(user.roles);
            
            $rootScope.$broadcast(Event.USER.CHANGE_PASSWORD.SUCCESS, user);
            baseModel.broadcastOperationSucceeded();
          },
          function (error) {
            $rootScope.$broadcast(Event.USER.CHANGE_PASSWORD.ERROR, error);
          }
        )
      };
      
      this.resetPassword = function (user) {
        userService.resetPassword(user).then(
          function (data) {
            $rootScope.$broadcast(Event.USER.RESET_PASSWORD.SUCCESS, data);
            baseModel.broadcastOperationSucceeded();
          },
          function (error) {
            $rootScope.$broadcast(Event.USER.RESET_PASSWORD.ERROR, error);
            baseModel.broadcastOperationFailed();
          }
        )
      };
      
      this.getLoggedUser = function () {
        userService.getLoggedUser().then(
          function (loggedUser) {
            self.currentUser = loggedUser;
            self.currentUserAuthorities = resolveAuthorities(loggedUser.roles);
            
            $rootScope.$broadcast(Event.USER.GET_LOGGED_USER.SUCCESS, loggedUser);
          },
          function (error) {
            $rootScope.$broadcast(Event.USER.GET_LOGGED_USER.ERROR, error);
          }
        )
      };
      
      this.getRoleList = function (criteria) {
        userService.getRoleList(criteria).then(
          function (list) {
            $rootScope.$broadcast(Event.USER.GET_ROLE_LIST.SUCCESS, list);
          },
          function (error) {
            $rootScope.$broadcast(Event.USER.GET_ROLE_LIST.ERROR, error);
          }
        )
      };
      
      this.userHasRight = function (rightName) {
        var foundRight = _.find(self.currentUserAuthorities, function (right) {
          return right === rightName;
        });
        
        return foundRight ? true : false;
      };
      
      $rootScope.$on(Event.MODULE_CHANGED, function (event, fromModule, toModule) {
        if (fromModule == Constant.MODULE.USERS) {
          self.userListCriteria = null;
        }
      });
      
      function resolveAuthorities(roles) {
        var authorities = [];
        
        if (_.isEmpty(roles)) {
          return authorities;
        }
        
        var rights = _.map(roles, 'rights');
        var flattenRights = _.flatten(rights);
        
        return _.map(flattenRights, 'name');
      }
      
      function getCurrentContextDoctorId() {
        if (self.currentUser) {
          if (self.currentUser.userType === Enum.USER_TYPE.DOCTOR) {
            return self.currentUser.id;
          } else {
            if (self.currentUser.doctorIds && self.currentUser.doctorIds.length > 0) {
              return self.currentUser.doctorIds[0];
            }
          }
        }
      }
    }
    
    return new UserModel();
  }
]);
